import React from 'react';
import { useRoleActions } from '~/util/useRoleActions';
import { BookmarkModal } from '~/components/Patient';

interface BookmarksProps {
    riskGap: RiskGapType;
    patientGmpi: number;
}

export function Bookmarks({ riskGap, patientGmpi }: BookmarksProps) {
    const canShow = useRoleActions('allow_open_bookmark_documents', null);
    const [iconHover, setIconHover] = React.useState(false);
    const [show, setShow] = React.useState(false);

    if (!canShow && riskGap.metadata?.BookmarkFileDataId) {
        return (
            <button
                type="button"
                className="bookmark-document mt-2 disabled"
                title="You don’t have permission to view Bookmark Documents on this record"
            >
                <i className="fa-regular fa-bookmark">
                    <span className="sr-only">Bookmarked Document Unavailable</span>
                </i>
            </button>
        );
    }

    return riskGap.metadata?.BookmarkFileDataId ? (
        <div>
            <button
                type="button"
                className="bookmark-document mt-2"
                title="Bookmark document"
                onMouseEnter={() => setIconHover(true)}
                onMouseLeave={() => setIconHover(false)}
                onFocus={() => setIconHover(true)}
                onBlur={() => setIconHover(false)}
                onClick={() => setShow(true)}
            >
                <i className={`fa-${!iconHover ? 'regular' : 'solid'} fa-bookmark`}>
                    <span className="sr-only">View Bookmarked Document</span>
                </i>
            </button>
            {show && (
                <BookmarkModal
                    handleClose={() => setShow(false)}
                    patientGmpi={patientGmpi}
                    fileId={riskGap.metadata?.BookmarkFileDataId || ''}
                    bookmarkPage={riskGap.metadata?.BookmarkPageNumber || ''}
                />
            )}
        </div>
    ) : (
        <div>&nbsp;</div>
    );
}
